import { FC } from 'react';

const SVGNegociacaoDificil: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.55895 10.678C8.59116 10.6154 8.60727 10.5513 8.60727 10.4858C8.60724 9.78079 6.68018 9.20835 4.30361 9.20844C1.92703 9.20854 2.2535e-05 9.78114 5.02834e-05 10.4861C6.78293e-05 10.9319 2.90234 11.1995 1.93445 11.5527C1.22134 11.8604 0.80549 12.2293 0.805505 12.6252C0.805548 13.7076 3.90699 14.5862 7.73323 14.586C11.5595 14.5858 14.6609 13.7084 14.6608 12.6246C14.6608 11.6206 11.9957 10.7932 8.55895 10.678Z"
        fill="url(#paint0_linear_4688_38)"
      />
      <path
        d="M4.30238 14.1974L4.30225 10.9175L6.88675 10.9174L6.8869 14.4436L4.30238 14.1974Z"
        fill="url(#paint1_linear_4688_38)"
      />
      <path
        d="M7.37905 14.4065L7.37891 10.9172L8.43321 10.9172L8.43335 14.3893L7.37905 14.4065Z"
        fill="url(#paint2_linear_4688_38)"
      />
      <path
        d="M6.7405 0.211737L2.82939 1.64604C2.38424 1.80983 2.08701 2.2371 2.08703 2.71562L2.08734 10.2168C2.08736 10.6383 2.37145 11.0058 2.7756 11.1054L9.55689 12.7943C10.0884 12.9267 10.6449 12.8968 11.1588 12.7087L15.1769 11.236C15.6703 11.0551 15.9998 10.5808 15.9997 10.0482L15.9994 2.97714C15.9994 2.35335 15.5791 1.81075 14.9817 1.65981L8.77442 0.104846C8.10083 -0.064606 7.39357 -0.0275502 6.7405 0.211737Z"
        fill="url(#paint3_radial_4688_38)"
      />
      <path
        d="M15.6041 2.6923C14.8134 2.83902 12.8834 3.54549 12.8834 3.54549C11.2581 4.18644 10.4161 4.36876 10.4162 5.74025C10.4162 5.74025 10.39 9.51148 10.4339 10.2321C10.494 11.192 10.6448 11.5808 11.9495 11.2261L13.9117 10.6265C14.6292 10.3786 15.7216 10.2376 15.5809 7.76238C15.4754 5.91807 15.6041 2.6923 15.6041 2.6923Z"
        fill="url(#paint4_linear_4688_38)"
      />
      <path
        d="M7.095 3.66673L3.1706 2.6956C2.7357 2.59735 2.27316 6.93114 4.16955 9.54159C5.06136 10.7692 6.66624 10.6509 7.7352 10.9058C8.7734 11.1536 9.10581 11.3629 9.10581 11.3629L9.10558 5.7602C9.10552 4.34884 9.10552 4.34884 7.095 3.66673Z"
        fill="url(#paint5_radial_4688_38)"
      />
      <path
        d="M7.93246 0.549306C8.17261 0.549297 8.41129 0.579195 8.64412 0.637578L14.8543 2.19397C15.2116 2.28368 15.4606 2.60553 15.4606 2.97867L15.4609 10.0497C15.4609 10.3488 15.2735 10.6194 14.9953 10.7205L10.9773 12.1933C10.7342 12.283 10.4794 12.3272 10.2202 12.3272C10.0416 12.3272 9.86291 12.3058 9.68866 12.2617L2.90737 10.5743C2.74483 10.5344 2.63061 10.3877 2.6306 10.2183L2.63029 2.71569C2.63028 2.46788 2.78402 2.2457 3.01391 2.16167L6.92503 0.728791C7.2501 0.609148 7.58835 0.549319 7.93246 0.549306ZM7.93244 0.000996922C7.52829 0.00101239 7.12561 0.0722367 6.7405 0.213245L2.82939 1.64612C2.38424 1.80992 2.08701 2.23718 2.08703 2.71571L2.08734 10.2169C2.08736 10.6384 2.37145 11.0058 2.7756 11.1055L9.55689 12.7943C9.77361 12.8484 9.99619 12.8755 10.2173 12.8755C10.5365 12.8755 10.8557 12.8199 11.1588 12.7088L15.1769 11.2361C15.6703 11.0552 15.9998 10.5809 15.9997 10.0483L15.9994 2.97722C15.9994 2.35343 15.5791 1.81084 14.9817 1.6599L8.77442 0.10493C8.49767 0.0351555 8.21505 0.000986103 7.93244 0.000996922Z"
        fill="url(#paint6_linear_4688_38)"
      />
      <path
        d="M8.83341 11.2746C8.81584 11.2718 7.57702 11.0867 5.40103 10.4886C4.41847 10.218 3.27045 10.2537 3.31284 8.26269C3.3333 7.26719 3.39907 4.29065 3.39906 4.16247C3.39906 4.16247 3.99951 6.04806 4.14456 8.26693C4.20903 9.25531 4.55755 9.50595 5.59283 9.82777C8.16712 10.6295 8.83341 11.2746 8.83341 11.2746Z"
        fill="white"
      />
      <path
        d="M3.94439 2.34818C3.95318 2.34534 4.63554 2.07756 6.60646 1.24719C7.82036 0.735863 8.69456 0.963697 9.80306 1.25276C9.93631 1.28694 10.074 1.32254 10.2175 1.35956C11.4153 1.66002 13.4185 2.17691 13.4273 2.17976C13.4273 2.17976 11.8414 2.47748 9.62004 1.91644C8.52912 1.64019 7.89214 1.50492 6.88617 1.87809C4.98992 2.58028 3.94439 2.34818 3.94439 2.34818Z"
        fill="#29B6F6"
      />
      <path
        d="M10.3962 11.3615C10.3948 11.343 10.26 8.99877 10.2584 6.64745C10.2583 4.96834 10.0811 4.24059 11.9906 3.63951C13.061 3.30194 14.7127 2.90596 14.7903 2.88459C14.7903 2.88459 13.9029 3.6138 12.2556 4.27469C11.38 4.62649 10.9715 5.37563 10.9642 6.65027C10.9424 9.83758 10.3962 11.3615 10.3962 11.3615Z"
        fill="#1565C0"
      />
      <path
        d="M13.9594 15.859C14.904 15.859 15.6697 15.4757 15.6697 15.003C15.6697 14.5303 14.9039 14.1471 13.9593 14.1471C13.0148 14.1472 12.249 14.5304 12.2491 15.0031C12.2491 15.4759 13.0148 15.859 13.9594 15.859Z"
        fill="url(#paint7_linear_4688_38)"
      />
      <path
        d="M15.6716 15.0029C15.6833 15.0869 15.6745 15.1795 15.6364 15.2635C15.5998 15.3461 15.5442 15.4231 15.4812 15.4886C15.3509 15.6196 15.1928 15.7179 15.0244 15.7905C14.8574 15.866 14.6803 15.9144 14.5031 15.95C14.3244 15.9828 14.1429 15.9956 13.9613 15.9999C13.7797 15.9956 13.5981 15.9814 13.4195 15.9501C13.2408 15.9131 13.0637 15.8661 12.8982 15.7906C12.7312 15.718 12.5716 15.6197 12.4413 15.4887C12.3769 15.4232 12.3227 15.3463 12.2861 15.2637C12.248 15.1797 12.2392 15.0871 12.2509 15.0031C12.289 15.1725 12.4003 15.2979 12.5365 15.3847C12.6697 15.4744 12.8235 15.5357 12.9802 15.5841C13.295 15.6781 13.6289 15.7165 13.9613 15.7165C14.2937 15.7165 14.6275 15.678 14.9424 15.584C15.099 15.5356 15.2528 15.4743 15.386 15.3832C15.5222 15.2977 15.6335 15.1724 15.6716 15.0029Z"
        fill="#01579B"
      />
      <path
        d="M13.7273 15.0031C14.0775 15.0031 14.3614 14.8723 14.3614 14.7111C14.3614 14.5499 14.0775 14.4192 13.7273 14.4192C13.3771 14.4192 13.0933 14.5499 13.0933 14.7111C13.0933 14.8724 13.3772 15.0031 13.7273 15.0031Z"
        fill="url(#paint8_linear_4688_38)"
      />
      <path
        d="M0.000976562 10.5145C0.122521 10.6755 0.318741 10.7495 0.503247 10.8179C0.692146 10.8834 0.885437 10.9346 1.08019 10.9802L1.66885 11.1126C1.76696 11.1368 1.86507 11.1596 1.96464 11.1924C2.01443 11.2094 2.06422 11.228 2.11401 11.2564C2.1389 11.2721 2.16672 11.2892 2.19015 11.3262C2.21798 11.3661 2.2048 11.4359 2.17844 11.4615C2.13012 11.5185 2.0818 11.5413 2.03348 11.5655C1.9837 11.5897 1.93684 11.6082 1.89291 11.6282C1.80212 11.6666 1.71427 11.7108 1.62787 11.7563C1.45655 11.8475 1.29402 11.9557 1.15784 12.0853C1.0246 12.2135 0.920637 12.3702 0.910393 12.5297C0.89722 12.6892 0.988014 12.8459 1.11688 12.9712C1.38193 13.2261 1.74948 13.3884 2.11263 13.5294C2.48018 13.6661 2.86383 13.7715 3.25041 13.8584C4.0265 14.0307 4.8187 14.1417 5.61529 14.21C6.41188 14.2798 7.21139 14.3111 8.01237 14.3039C8.81335 14.3039 9.61286 14.2597 10.4094 14.1828C11.2046 14.1002 11.9982 13.9819 12.7699 13.7782C13.155 13.6771 13.5357 13.5546 13.8915 13.3794C14.0687 13.2911 14.2386 13.1886 14.385 13.0575C14.5285 12.9293 14.6544 12.7599 14.6617 12.5605C14.6705 12.7599 14.5549 12.9464 14.4172 13.0889C14.2752 13.2327 14.1053 13.3466 13.9296 13.4463C13.5767 13.6443 13.196 13.7896 12.8109 13.9135C12.0378 14.1528 11.2382 14.3024 10.4358 14.405C8.82947 14.6058 7.20262 14.6273 5.58894 14.492C4.7821 14.418 3.97819 14.307 3.18746 14.1176C2.79209 14.0222 2.40112 13.9082 2.02039 13.7573C1.83003 13.6818 1.64259 13.5978 1.46248 13.4953C1.28236 13.3927 1.1081 13.2745 0.957274 13.1193C0.882591 13.0424 0.816693 12.9527 0.768367 12.8501C0.721505 12.7476 0.695143 12.6294 0.708317 12.514C0.731737 12.2776 0.879625 12.0939 1.03484 11.9558C1.19298 11.8176 1.37162 11.7094 1.55612 11.6196C1.64837 11.5755 1.74208 11.5342 1.83726 11.4971C1.88558 11.4786 1.93244 11.4615 1.9749 11.4444C2.0159 11.4273 2.05983 11.4031 2.07594 11.3846C2.0818 11.3732 2.07887 11.3875 2.08033 11.3832C2.07887 11.3775 2.06422 11.3647 2.04812 11.3533C2.01297 11.3305 1.96904 11.3106 1.92511 11.2935C1.83432 11.2593 1.73914 11.2308 1.64396 11.2023L1.06262 11.0414C0.869331 10.9859 0.67604 10.9275 0.490069 10.8492C0.307028 10.7737 0.112271 10.6826 0.000976562 10.5145Z"
        fill="#01579B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4688_38"
          x1="7.33083"
          y1="10.4905"
          x2="7.331"
          y2="14.8196"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0404" stopColor="#1E88E5" stopOpacity="0.9788" />
          <stop offset="1" stopColor="#B3E5FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4688_38"
          x1="5.59468"
          y1="11.6647"
          x2="5.59483"
          y2="15.6429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.7223" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4688_38"
          x1="7.90623"
          y1="11.6413"
          x2="7.90639"
          y2="15.5786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.7223" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_4688_38"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.70157 10.0465) scale(9.81337 9.54442)"
        >
          <stop stopColor="#E0F7FA" />
          <stop offset="0.3207" stopColor="#C5EDFA" />
          <stop offset="0.9933" stopColor="#81D4FA" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4688_38"
          x1="11.7254"
          y1="2.94938"
          x2="14.0209"
          y2="9.91952"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0404" stopColor="#1E88E5" stopOpacity="0.9788" />
          <stop offset="0.2166" stopColor="#1E88E5" stopOpacity="0.9788" />
          <stop offset="1" stopColor="#1976D2" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_4688_38"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.4683 4.0517) scale(7.88864 7.98381)"
        >
          <stop offset="0.2675" stopColor="white" stopOpacity="0.9788" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint6_linear_4688_38"
          x1="9.04515"
          y1="-3.98091"
          x2="9.04574"
          y2="11.5199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#81D4FA" />
          <stop offset="0.5111" stopColor="#1E88E5" stopOpacity="0.9788" />
          <stop offset="0.7791" stopColor="#1976D2" stopOpacity="0.9853" />
          <stop offset="1" stopColor="#0D47A1" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4688_38"
          x1="13.9594"
          y1="14.5545"
          x2="13.9594"
          y2="15.9331"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0404" stopColor="#1E88E5" stopOpacity="0.9788" />
          <stop offset="1" stopColor="#B3E5FC" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4688_38"
          x1="13.7273"
          y1="14.4078"
          x2="13.7273"
          y2="15.0686"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.7223" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SVGNegociacaoDificil;
